var _rect, _path, _circle, _circle2, _circle3, _path2, _text, _text2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCloud(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 320 200",
    role: "img",
    "aria-label": "Cloud DevOps logo badge",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 320,
    height: 200,
    rx: 22,
    fill: "#f7fbff"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M71 134h102c25 0 42-15 42-37 0-20-15-35-36-37-11-24-34-38-63-34-28 4-48 26-51 53-20 4-35 18-35 37 0 12 16 18 41 18z",
    fill: "#dbeafe",
    stroke: "#0071bc",
    strokeWidth: 8,
    strokeLinejoin: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 88,
    cy: 152,
    r: 12,
    fill: "#15bfe8"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 146,
    cy: 152,
    r: 12,
    fill: "#15bfe8"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 204,
    cy: 152,
    r: 12,
    fill: "#15bfe8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M146 134v18M88 140v12M204 140v12",
    stroke: "#0b2f55",
    strokeWidth: 6,
    strokeLinecap: "round"
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 178,
    y: 86,
    fontFamily: "Arial, sans-serif",
    fontSize: 30,
    fontWeight: 800,
    fill: "#0b2f55"
  }, "CLOUD")), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    x: 180,
    y: 119,
    fontFamily: "Arial, sans-serif",
    fontSize: 23,
    fontWeight: 800,
    fill: "#0b2f55"
  }, "DEVOPS")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloud);
export default __webpack_public_path__ + "static/media/cloud.9351d988d723ed0ea185b7521db1a1ae.svg";
export { ForwardRef as ReactComponent };